const hasSlider = document.querySelector('.js-start-now-slider__slider .swiper');

if (hasSlider) {
	Promise.all([
		import('swiper'),
		import(
			/* webpackExports: ["Navigation", "Pagination", "EffectFlip"] */
			'swiper/modules'
		),
	])
		.then(([{ default: Swiper }, { Navigation, Pagination, EffectFlip }]) => {
			const swiper = new Swiper('.js-start-now-slider__slider .swiper', {
				effect: 'flip',
				slidesPerView: 'auto',
				pagination: {
					el: '.js-start-now-slider__slider .swiper-pagination',
				},
				navigation: {
					prevEl: '.js-start-now-slider__slider-arrow-left',
					nextEl: '.js-start-now-slider__slider-arrow-right',
				},
				modules: [Navigation, Pagination, EffectFlip],
			});
		})
		.catch((err) => console.error(err));
}
